import {styled, Typography} from '@innowise-group/ui-kit';

export const RoomInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RoomTypeContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RoomTypeWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2px;
`;

export const RoomTypeText = styled(Typography)<{isEditRoom: boolean}>`
  color: ${({theme, isEditRoom}) => (isEditRoom ? theme.palette.general.smart : theme.palette.general.darkGrey[60])};
`;

export const AttendanceInfo = styled.div<{hasContent: boolean}>`
  margin: ${({hasContent}) => (hasContent ? '16px' : '0')};

  p {
    padding-left: 0;
  }
`;
export const StatsBlock = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  font-weight: 500;
`;
